import { SVGProps } from 'react';

export const WarningIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="7" cy="7.875" r="5.25" fill="#EC465A" />
            <path
                d="M6.94154 11.083C7.17487 11.083 7.4082 10.908 7.4082 10.6747C7.4082 10.383 7.17487 10.208 6.94154 10.208C6.7082 10.208 6.5332 10.383 6.5332 10.6163C6.5332 10.8497 6.7082 11.083 6.94154 11.083Z"
                fill="white"
            />
            <path
                d="M6.41699 4.95801H7.46699L7.29199 9.50801H6.59199L6.41699 4.95801Z"
                fill="white"
            />
        </svg>
    );
};
